<div>
  <app-modal-header title="View Evidence" (closeModal)="closeModal()"></app-modal-header>

  <div class="max-h-[60vh] overflow-y-auto">
    <img [src]="fileUrl+filePath" class="w-full" alt="">
  </div>
</div>
